import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AmplifyAuthService } from '../services/auth/amplify-auth.service';
import { DialogService } from '../services/dialog/dialog.service';
import { LoadingService } from '../services/loading/loading.service';
import { RumInitializerService } from '../services/rum/rum-initializer.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const amplifyAuthService = inject(AmplifyAuthService);
  const dialogService = inject(DialogService);
  const loadingService = inject(LoadingService);
  const rumService = inject(RumInitializerService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        const isAWSRequest = req.url.includes('amazonaws.com') ||
                            req.url.includes('cognito') ||
                            req.url.includes('amplify');
        const errorMessage = error.error?.message || error.message || '';
        const isTokenError = errorMessage.includes('token') ||
                            errorMessage.includes('Unauthorized') ||
                            errorMessage.includes('expired') ||
                            error.error?.code === 'UnauthorizedException';

        if (isAWSRequest && isTokenError) {
          rumService.recordError(error);
          loadingService.resetAll();
          amplifyAuthService.logout();
          return throwError(() => error);
        }

        return throwError(() => error);
      }

      if (error.status === 403) {
        rumService.recordError(error);
        dialogService.warning("No tienes permisos para realizar esta acción");
        return throwError(() => error);
      }

      if (error.status === 0 || error.status >= 500) {
        rumService.recordError(error);
        dialogService.error("Se ha producido un error contacte a soporte@mbcloud.cl");
      }

      return throwError(() => error);
    })
  );
};
